import GoAiguaModal from "components/generic/goaiguamodal";
import { useEffect, useState } from "react";
import {
    addUserPermissions,
    editUserDetails,
    removeUserPermissions,
} from "services/requests/v1/user";

import { useRequestStatusManager } from "utils/hooks/use-request-status-manager.hook";

import { useTranslation } from "utils/hooks/use-translation.hook";
import ToastRequestHandler from "./toast-request-handler";
import UserModalContent from "./usermodalcontent";

type UserDetailModalType = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    userUid: string;
    userDataRef: any;
};

const UserDetailModal = ({
    isOpen,
    setIsOpen,
    userUid,
    userDataRef,
}: UserDetailModalType) => {
    const [metadata, setMetadata] = useState<any>({});
    const translate = useTranslation();
    const [triggerEdit, setTriggerEdit] = useState<boolean>(false);

    const {
        allContentIsReady,
        removeAllData,
        errorList,
        success,
        subscribeContent,
        unsubscribeContent,
        setError,
    } = useRequestStatusManager();

    useEffect(() => {
        const contentName = "editUser";

        if (triggerEdit) {
            (async () => {
                try {
                    subscribeContent(contentName);

                    let requestBody = {
                        email: metadata.email,
                        enabled: metadata.enabled,
                        firstName: metadata.firstName,
                        lastName: metadata.lastName,
                        username: metadata.username,
                        password: metadata.password,
                        locale: metadata.locale,
                        telephone: metadata.telephone,
                    };

                    await editUserDetails(userUid, requestBody);

                    await addUserPermissions(
                        userUid,
                        metadata.allowedPermissions
                    );

                    // await removeUserPermissions(
                    //     userUid,
                    //     metadata.disallowedPermissions
                    // );

                    if (userDataRef && userDataRef.node) {
                        userDataRef.node.setData({
                            ...userDataRef.node.data,
                            ...requestBody,
                        });
                    }

                    unsubscribeContent(contentName, true);
                } catch (error) {
                    setError(contentName);
                }
            })();
            setTriggerEdit(false);
        }
    }, [triggerEdit]);

    return (
        <>
            <GoAiguaModal
                headerTitle={translate("app.components.userDetails.title")}
                isOpen={isOpen}
                className="create-user"
                setIsOpen={setIsOpen}
            >
                <UserModalContent
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    editUserModal={true}
                    userUid={userUid}
                    metadata={metadata}
                    setMetadata={setMetadata}
                    setCallbackTrigger={setTriggerEdit}
                    subscribeContent={subscribeContent}
                    unsubscribeContent={unsubscribeContent}
                    setError={setError}
                />
            </GoAiguaModal>
            <ToastRequestHandler
                allContentIsReady={allContentIsReady}
                closeToast={removeAllData}
                errorList={errorList}
                success={success}
            />
        </>
    );
};

export default UserDetailModal;
